import { render, staticRenderFns } from "./sv-panel.vue?vue&type=template&id=19ca20e8&"
import script from "./sv-panel.vue?vue&type=script&lang=js&"
export * from "./sv-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports